import { connect, mapProps } from '@formily/react'
import { Switch as UISwitch } from '@/components/ui/switch'

export interface FormilySwitchProps {
  value?: boolean
  onChange?: (checked: boolean) => void
  className?: string
  disabled?: boolean
}

const InternalSwitch = ({ value, onChange, ...props }: FormilySwitchProps) => {
  return <UISwitch checked={value} onCheckedChange={onChange} {...props} />
}

export const FormilySwitch = connect(
  InternalSwitch,
  mapProps((props) => ({
    ...props,
    value: props.value || false,
  })),
)

FormilySwitch.displayName = 'FormilySwitch'
